// @flow

import React from 'react';
import { Modal } from '@finect/tabular-components/Modal';
import { ButtonLined } from '@finect/tabular-core/ButtonLined';
import { Icon } from '@finect/tabular-components/Icon';
import { IconContent, ModalTitle, ActionsInner, Actions, ButtonRefuse } from '../partials';

export const ModalRefuse = ({
  organization,
  serviceId,
  handleCloseModal,
  handleRefuse
}: {
  organization: Object,
  serviceId: string,
  handleCloseModal: Function,
  handleRefuse: Function
}) => (
  <Modal show={Boolean(organization.id && serviceId)} onClose={handleCloseModal}>
    <IconContent>
      <Icon type="company" image={`/image/${organization.icon}`} alt={organization.displayName} size={3} />
    </IconContent>
    <ModalTitle>{`¿De verdad quieres rechazar a ${organization.displayName} como asesor?`}</ModalTitle>

    <ActionsInner>
      <Actions>
        <ButtonLined width="auto" onClick={handleCloseModal}>
          {'Ahora no'}
        </ButtonLined>
        <ButtonRefuse width="136px" onClick={handleRefuse}>
          {'Si, Quiero'}
        </ButtonRefuse>
      </Actions>
    </ActionsInner>
  </Modal>
);
